import { trackCustomEvent } from '../Config/DataDog';
import ModosUrl from '../Models/ModosUrl';
import sitiosId from '../Models/SitiosId';
import RegexValidator from './regexValidator';
import SomeInArray from './SomeInArray';
import * as storage from './../Helpers/Auth0StorageManager';

const GetParamURL = () => {
    try {
        let location = new URL(document.location);
        let params = location.searchParams;
        const { rawModo, rawSitioId } = getPathArray(location);

        let isParamsCallback = params.get('callback');
        let loginHint = params.get('login_hint');

        const decodeCallBack = base64Decode(isParamsCallback);
        const decodeUserEmail = base64Decode(loginHint);

        const modo =
            rawModo && SomeInArray(ModosUrl, rawModo)
                ? rawModo
                : storage.getModo();

        const sitioId =
            rawSitioId && SomeInArray(sitiosId, rawSitioId)
                ? rawSitioId
                : storage.getSitioId();

        const urlCallback = RegexValidator.dominiosPermitidos.test(
            decodeCallBack || ''
        )
            ? decodeCallBack
            : process.env.REACT_APP_LNREDIRECT;

        return {
            Modo: modo || null,
            SitioId: sitioId || null,
            URLCallback: urlCallback,
            UserEmail: decodeUserEmail || undefined,
        };
    } catch (error) {
        trackCustomEvent('Ingresar - GetParamUrl', true, {
            message: error.message,
            path: location.pathname,
        });
        console.log('Ingresar - GetParamUrl, no se pudo obtener modo y sitio');
    }
};

function base64Decode(value) {
    try {
        return window.atob(value);
    } catch {
        return null;
    }
}

const getPathArray = (location) => {
    let pathArray = location.pathname.split('/').filter((item) => item !== '');
    const [rawModo, rawSitioId] = pathArray.slice(-2);
    return { rawModo, rawSitioId };
};
export default GetParamURL;
